module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_condor-3694dc3e914c7e8c3a201832f6ea1039.jpg";